<template>
  <div>
    <div class="main-title">计费套餐管理</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="add">新增计费套餐</el-button>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索套餐名称"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              style="width:220px"
              @input="inputSearch(searchForm)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column
          prop="id"
          label="系统编号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="所属科目"
          width="120">
        </el-table-column>
        <el-table-column
          prop="name"
          label="套餐名称"
          width="160">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          width="100">
        </el-table-column>
        <el-table-column
          prop="fee"
          label="单价"
          width="80">
        </el-table-column>
        <el-table-column
          prop="max_time"
          label="时长(分钟)"
          width="100">
        </el-table-column>
        <el-table-column
          prop="exam_service"
          label="培训服务"
          v-if="[1,10].indexOf(user.group_id) >= 0"
          width="80">
        </el-table-column>
        <el-table-column
          prop="is_return"
          label="是否可返现"
          width="100">
        </el-table-column>
        <!--
        <el-table-column
          label="返现方式"
          width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.is_return === '否'">不返现</span>
            <span v-if="scope.row.is_return === '是' && scope.row.return_type === '0'">按比例返现</span>
            <span v-if="scope.row.is_return === '是' && scope.row.return_type === '1'">固定金额:{{ scope.row.return_money }}元</span>
          </template>
        </el-table-column>
        -->
        <el-table-column
          prop="is_refund"
          label="是否可退款"
          v-if="[1,10].indexOf(user.group_id) >= 0"
          width="100">
        </el-table-column>
        <el-table-column
          prop="is_prepaid"
          label="是否为预收"
          v-if="[1,10].indexOf(user.group_id) >= 0"
          width="100">
        </el-table-column>
        <el-table-column
          prop="prepaid_refund"
          label="预收需退款"
          v-if="[1,10].indexOf(user.group_id) >= 0"
          width="100">
        </el-table-column>
        <el-table-column
          prop="is_free"
          label="是否可免单"
          v-if="[1,10].indexOf(user.group_id) >= 0"
          width="100">
        </el-table-column>
        <el-table-column
          prop="order_no"
          label="序号"
          width="70">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="70">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
            <el-button type="text" v-if="scope.row.status === '启用'" @click="invalid(scope.row)" style="color:#f56c6c;">停用</el-button>
            <el-button type="text" v-else @click="valid(scope.row)">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增计费套餐 -->
    <el-dialog :title="addForm.id > 0 ? '修改套餐' : '新增套餐'" :visible.sync="addFormVisible">
      <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="120px">
        <el-form-item label="科目">
          <el-select v-model="addForm.company_id">
            <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="type" v-if="addForm.id == 0">
          <el-select v-model="addForm.type" @change="changeType">
            <el-option label="一口价" value="一口价"></el-option>
            <el-option label="按分钟计费" value="按分钟计费"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="单价" prop="fee">
          <el-input v-model="addForm.fee"></el-input>
        </el-form-item>
        <el-form-item label="时长(分钟)" prop="max_time">
          <el-input v-model.number="addForm.max_time" :disabled="addForm.type == '按分钟计费'"></el-input>
        </el-form-item>
        <el-form-item label="培训服务" v-if="[1,10].indexOf(user.group_id) >= 0 && addForm.type != '按分钟计费'">
          <el-select v-model="addForm.exam_service">
            <el-option v-for="item in examServiceList" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可返现">
          <el-select v-model="addForm.is_return">
            <el-option label="否" value="否"></el-option>
            <el-option label="是" value="是"></el-option>
          </el-select>
        </el-form-item>
        <!--
        <el-form-item label="返现方式" v-if="addForm.is_return === '是'">
          <el-select v-model="addForm.return_type">
            <el-option label="按比例返现" value="0"></el-option>
            <el-option label="固定金额返现" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="返现固定金额" v-if="addForm.is_return === '是' && addForm.return_type === '1'">
          <el-input v-model.number="addForm.return_money"></el-input>
        </el-form-item>
        -->
        <el-form-item label="是否可退款" v-if="[1,10].indexOf(user.group_id) >= 0 && addForm.type != '按分钟计费'">
          <el-select v-model="addForm.is_refund">
            <el-option label="否" value="否"></el-option>
            <el-option label="是" value="是"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否为预收" v-if="[1,10].indexOf(user.group_id) >= 0 && addForm.type != '按分钟计费'">
          <el-select v-model="addForm.is_prepaid">
            <el-option label="否" value="否"></el-option>
            <el-option label="是" value="是"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预收需退款(元)" v-if="[1,10].indexOf(user.group_id) >= 0 && addForm.type != '按分钟计费'">
          <el-input v-model.number="addForm.prepaid_refund"></el-input>
        </el-form-item>
        <el-form-item label="是否可免单" v-if="[1,10].indexOf(user.group_id) >= 0 && addForm.type != '按分钟计费'">
          <el-select v-model="addForm.is_free">
            <el-option label="否" value="否"></el-option>
            <el-option label="是" value="是"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="序号" prop="order_no">
          <el-input v-model.number="addForm.order_no"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addFormCommit" :loading="addFormCommiting">确 定</el-button>
        <el-button @click="addFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
export default {
  props: {
    user: Object
  },
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'fee_package_list',
      pageSize: 0,
      searchForm: {
        query: ''
      },
      addForm: {
        id: 0,
        company_id: 0,
        type: '一口价',
        name: '',
        fee: 10,
        max_time: 10,
        is_return: '否',
        return_type: '0',
        return_money: 0,
        is_refund: '否',
        is_prepaid: '否',
        is_free: '否',
        prepaid_refund: 0,
        order_no: 0,
        exam_service: '4'
      },
      addFormRules: {
        name: [
          { required: true, message: '请输入套餐名称', trigger: 'blur' }
        ],
        fee: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ],
        max_time: [
          { required: true, message: '请输入最大时长', trigger: 'blur' }
        ],
        order_no: [
          { required: true, message: '请输入序号', trigger: 'blur' }
        ]
      },
      addFormVisible: false,
      addFormCommiting: false,
      companyList: [],
      examServiceList: []
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.fetchExamServiceList()
  },
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (row.status === '停用') {
        return 'row-red'
      } else {
        return ''
      }
    },
    fetchExamServiceList () {
      this.$http.get('/dbapi/sys_combo_list?name=培训服务').then(response => {
        if (response.data.success) {
          this.examServiceList = response.data.list
        }
      })
    },
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          if (this.companyList.length > 0) {
            this.addForm.company_id = this.companyList[0].value
          }
        }
      })
    },
    add () {
      this.addForm = {
        id: 0,
        company_id: this.companyList.length > 0 ? this.companyList[0].value : 0,
        type: '一口价',
        name: '',
        fee: 10,
        max_time: 10,
        is_return: '否',
        return_type: '0',
        return_money: 0,
        is_refund: '否',
        is_prepaid: '否',
        is_free: '否',
        prepaid_refund: 0,
        order_no: 0,
        exam_service: '4'
      }
      this.addFormVisible = true
    },
    edit (row) {
      this.addForm = {
        id: row.id,
        company_id: row.company_id,
        type: row.type,
        name: row.name,
        fee: row.fee,
        max_time: row.max_time,
        is_return: row.is_return,
        return_type: row.return_type,
        return_money: row.return_money,
        is_refund: row.is_refund,
        is_prepaid: row.is_prepaid,
        is_free: row.is_free,
        prepaid_refund: row.prepaid_refund,
        order_no: row.order_no,
        exam_service: row.exam_service
      }
      this.addFormVisible = true
    },
    addFormCommit () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addFormCommiting = true
          let url = '/dbapi/fee_package_insert'
          if (this.addForm.id > 0) {
            url = '/dbapi/fee_package_update'
          }
          this.$http.post(url, this.addForm).then(response => {
            this.addFormCommiting = false
            if (response.data.success) {
              this.$refs.addForm.resetFields()
              this.addFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '保存成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    invalid (row) {
      this.$confirm('确定要停用这个套餐吗？', '提示', {
        confirmButtonText: '确定停用',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/fee_package_del', {
          id: row.id,
          status: '停用'
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    valid (row) {
      this.$confirm('确定要启用这个套餐吗？', '提示', {
        confirmButtonText: '确定启用',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/fee_package_del', {
          id: row.id,
          status: '启用'
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    changeType (t){
      if (t == '按分钟计费') {
        this.addForm.max_time = 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rent/FeePackage.vue